import React, { useEffect, useState } from 'react'
import RoomItem from '../rooms/roomItem/roomItem'
import {
    Col,
    Row,
    Button,
    Input,
    Modal,
    ModalHeader,
    ModalBody,
    Spinner,
} from 'reactstrap'
import { connect } from 'react-redux'
import { chooseRoom, getRooms, uploadRoom } from '../../../redux/tools/actions'
import { toast } from 'react-toastify'
import classames from 'classnames'
import UploadRoom from './roomItem/uploadRoom'

import './index.css'

const Index = (props) => {
    useEffect(() => {
        if (!props.error && !props.loading) {
            if (props.rooms && props.rooms.length > 0) return
            props.getRooms()
        }
    }, [])

    useEffect(() => {
        if (props.error) toast.error(props.error.toString())
    }, [props.error])

    const [isUploadRoomVisible, setIsUploadRoomVisible] = useState(false)
    const toggle = () => setIsUploadRoomVisible(!isUploadRoomVisible)

    const [rooms, setRooms] = useState([])
    useEffect(() => {
        setRooms(props.rooms)
    }, [props.rooms])

    const handleSearchChanged = (e) => {
        const word = e.target.value
        setRooms(props.rooms.filter((q) => q.title.includes(word)))
    }

    const containerClassname = classames({
        'rooms-row': true,
        'is-loading': props.loading,
        'w-100': true,
    })

    return (
        <Row className={containerClassname}>
            <div
                className="w-100"
                style={{
                    margin: '0 auto',
                    marginBottom: '10px',
                    paddingLeft: '10px',
                    paddingRight: '10px',
                }}
            >
                <Input
                    placeholder="جستجوی اتاق..."
                    onChange={handleSearchChanged}
                />
            </div>
            {rooms.map((room, index) => {
                return (
                    <Col key={index} lg="4" className="">
                        <RoomItem
                            tabIndex={index}
                            room={room}
                            chooseRoomHandler={props.chooseRoom}
                        />
                    </Col>
                )
            })}
            <div className="tools-action">
                <Button onClick={toggle}>آپلود اتاق جدید</Button>
            </div>
            {props.loading && (
                <div className="loading-wrapper">
                    <Spinner
                        style={{ width: '3rem', height: '3rem' }}
                        color="light"
                    />
                    <h3>لطفا منتظر بمانید</h3>
                </div>
            )}
            <Modal
                isOpen={isUploadRoomVisible}
                toggle={toggle}
                className="upload-room-modal"
            >
                <ModalHeader toggle={toggle}>اتاق جدید</ModalHeader>
                <ModalBody>
                    <UploadRoom onClose={toggle} />
                </ModalBody>
            </Modal>
        </Row>
    )
}

const mapStateToProps = (state) => {
    return {
        rooms: state.tools.rooms,
        loading: state.tools.loading,
        error: state.tools.error,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        chooseRoom: (id) => dispatch(chooseRoom(id)),
        getRooms: () => dispatch(getRooms()),
        uploadRoom: (file) => dispatch(uploadRoom(file)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Index)
